module.exports = __webpack_public_path__ + "img/augustus.20ceba2a.png";